import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/storage-for-summer.jpg'),
    alt: 'storage for summer page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'storage for summer page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Affordable <span>Storage</span><span>for Summer Students</span>',
  description:
    'Store your belongings safely this summer with flexible storage. Whether traveling, moving, or needing space, we keep your items secure at no extra cost.',
  image: {
    url: '/images/v2/pages/landing-pages/storage-for-summer/hero-image.jpg',
    alt: 'Affordable Storage for Summer Students'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Register for Summer Storage' }
}

export const ourProcessSectionContent = {
  title: 'How Free Storage Places Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/storage-for-summer/how-free-storage-places-work.png',
    alt: 'How Free Storage Places Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Booking Process',
      description:
        'Securing your summer storage is simple. Choose your preferred location, unit size, and storage duration online to get started with no hassle.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/easy-booking-process.png',
        alt: 'Easy Booking Process'
      }
    },
    {
      id: 2,
      title: 'Safe and Secure Storage',
      description:
        'Our summer storage units are equipped with advanced security features, including 24/7 surveillance and monitored access, ensuring your items are always protected.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/safe-and-secure-storage.png',
        alt: 'Safe and Secure Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Access to Your Items',
      description:
        'You’ll have convenient access to your stored belongings during our extended hours, allowing you to retrieve your items whenever needed.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/flexible-access-to-your-items.png',
        alt: 'Flexible Access to Your Items'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Affordable Summer Storage Services',
  description:
    'At ShipAndStorage, we provide reliable summer storage solutions that give you peace of mind. Our flexible, secure, and cost-free storage options ensure your belongings are safe while you enjoy your summer break.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-for-summer/affordable-summer-storage-services.jpg',
    alt: 'Affordable Summer Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using Storage for Summer',

  cards: [
    {
      id: 1,
      title: 'Cost-Free Storage',
      description:
        'Enjoy the convenience of storing your belongings during the summer without worrying about storage fees.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/cost-free-storage.png',
        alt: 'Cost-Free Storage'
      }
    },
    {
      id: 2,
      title: 'Flexible Storage Duration',
      description:
        'Whether you need a few weeks or several months, our summer storage services are flexible to fit your schedule.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/flexible-storage-duration.png',
        alt: 'Flexible Storage Duration'
      }
    },
    {
      id: 3,
      title: 'Convenient and Accessible',
      description:
        'With extended hours and easy access to your storage unit, retrieving your belongings is always convenient.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/convenient-and-accessible.png',
        alt: 'Convenient and Accessible'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Storage for Summer?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'College Students',
          description:
            'Need a place to store your belongings between semesters or during a summer break? Our summer storage solutions are perfect for students looking for cost-effective storage options.'
        },
        {
          id: 2,
          title: 'Homeowners on Vacation',
          description:
            'Traveling for an extended period? Keep your home organized by storing your personal items with us during your summer vacation.'
        },
        {
          id: 3,
          title: 'Businesses and Entrepreneurs',
          description:
            'Store seasonal items, documents, or inventory safely while you focus on other aspects of your business.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/who-should-use-storage-for-summer.jpg',
        alt: 'Who Should Use Storage for Summer?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Explore Our Additional Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Business Storage Solutions',
      description:
        'For business owners needing secure, flexible storage, we offer affordable business storage solutions to meet your needs.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/business-storage-solution.png',
        alt: 'Business Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Business Storage' }
    },
    {
      id: 2,
      title: 'Moving Storage Solution',
      description:
        'Planning a move this summer? Our moving storage options provide a convenient, hassle-free way to store your belongings while transitioning to a new home.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/moving-storage-solution.png',
        alt: 'Moving Storage Solution'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Moving Storage' }
    },
    {
      id: 3,
      title: 'Luggage and Box Shipping Services',
      description: 'Ship your luggage or boxes locally or internationally with ease and affordable rates this summer.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/luggage-and-box-shipping-services.png',
        alt: 'Luggage and Box Shipping Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Box Storage' }
    },
    {
      id: 4,
      title: 'Residential Storage Services',
      description:
        'Whether renovating or preparing for a long summer vacation, our residential storage services provide the extra space you need.',
      image: {
        src: '/images/v2/pages/landing-pages/storage-for-summer/residential-storage-services.png',
        alt: 'Residential Storage Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Explore Residential Storage' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose ShipAndStorage for Summer Storage?',

  image: {
    url: '/images/v2/pages/landing-pages/storage-for-summer/why-choose-shipandstorage-for-summer-storage.jpg',
    alt: 'Why Choose ShipAndStorage for Summer Storage?'
  },

  articles: [
    {
      id: 1,
      title: 'Cost-Free Summer Storage',
      description:
        'Our summer storage options are completely free, giving you peace of mind while you store your items.'
    },
    {
      id: 2,
      title: 'Top Security Standards',
      description:
        'Your belongings are stored securely with round-the-clock surveillance and controlled access, ensuring their safety.'
    },
    {
      id: 3,
      title: 'Transparent and Clear Terms',
      description: 'There are no hidden fees—just clear and simple storage terms that work for your summer plans.'
    },
    {
      id: 4,
      title: 'Flexible Access Hours',
      description:
        'Our storage facilities offer flexible access hours, making it easy for you to retrieve your items at your convenience.'
    },
    {
      id: 5,
      title: 'Ideal for Short and Long-Term Storage',
      description:
        'Our summer storage services are perfect for both short-term and extended storage needs, with no minimum or maximum terms.'
    },
    {
      id: 6,
      title: 'Convenient Storage Locations',
      description:
        "With locations across the country, our summer storage solutions are easy to access, no matter where you're located."
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Affordable Summer Storage Services Available Now',
  description:
    'Affordable storage for summer students. Fast, secure storage solutions for your belongings while traveling or studying over the summer.',
  image: {
    src: '/images/v2/pages/landing-pages/storage-for-summer/affordable-summer-storage-services-available-now.png',
    alt: 'Affordable Summer Storage Services Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Reserve Your Summer Storage' }
}

export const ourPartnersSectionContent = {
  description:
    'ShipAndStorage partners with leading logistics providers to ensure the highest quality storage and shipping solutions.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx is a trusted global logistics leader, ensuring your belongings are safely stored and transported.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL’s global logistics services offer secure and reliable storage and transport for your items during the summer months.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides secure storage options and global shipping solutions, ensuring your items are handled with care throughout the process.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com/' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
